import { HSTabs } from "preline";
import { authService } from "../../services/authService";
import { userDetailStore, UserDetailType } from "../../stores/userDetailStore";
import { initDarkModeToggles } from "../../utils/dark-mode-toggles";

interface ModalTab {
  panel: string;
  tabId: string;
  sidebarId: string;
}

export const MODAL_TABS: Record<string, ModalTab> = {
  'my-profile': { panel: '#vertical-tab-myaccount-profile', tabId: 'myaccount-profile', sidebarId: '#my-account?tab=my-profile' },
  'notifications': { panel: '#vertical-tab-myaccount-notifications', tabId: 'myaccount-notifications', sidebarId: '#my-account?tab=notifications' },
  'refer-and-earn': { panel: '#vertical-tab-myaccount-refer-and-earn', tabId: 'myaccount-refer-and-earn', sidebarId: '#my-account?tab=refer-and-earn' },
  'subscription': { panel: '#vertical-tab-myaccount-subscription', tabId: 'myaccount-subscription', sidebarId: '#my-account?tab=subscription' },
  'storage': { panel: '#vertical-tab-myaccount-storage', tabId: 'myaccount-storage', sidebarId: '#my-account?tab=storage' },
  'plans': { panel: '#vertical-tab-myaccount-plans', tabId: 'myaccount-plans', sidebarId: '#my-account?tab=plans' },
  'API-keys': { panel: '#vertical-tab-myaccount-apikeys', tabId: 'myaccount-apikeys', sidebarId: '#my-account?tab=API-keys' },
  'webhooks': { panel: '#vertical-tab-myaccount-webhooks', tabId: 'myaccount-webhooks', sidebarId: '#my-account?tab=webhooks' },
  'manage-team': { panel: '#vertical-tab-myaccount-team', tabId: 'myaccount-team', sidebarId: '#my-account?tab=manage-team' }
};

// Update the URL with the tab name
export function updateUrl(tabName: string | null) {
  if (tabName) {
    const newUrl = `#my-account?tab=${tabName}`;
    const tabElement = document.getElementById(MODAL_TABS[tabName].tabId);
    if (tabElement) {
      HSTabs.open(tabElement);
    }

    window.history.pushState({}, '', newUrl);
  } else {
    const currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/#my-account\?tab=[^&]*(&|$)/, '');
    window.history.pushState({}, '', cleanedUrl);
  }
}

export function ProfileDropdown() {

  let userDetailStoreUnsubscribe: () => void;
  let $profileDropdown;
  let $headerAvatarBtn;
  let $dropdownHeaderAvatarBtn;
  let $dropdownHeaderNameElement;
  let $dropdownHeaderEmailElement;

  function init() {
    $profileDropdown = document.getElementById('header-profile-dd') as HTMLElement;
    $headerAvatarBtn = document.getElementById('header-profile-dd-btn');
    $dropdownHeaderAvatarBtn = document.getElementById('dropdown-header-profile-avatar');
    $dropdownHeaderNameElement = document.getElementById('dropdown-header-profile-name');
    $dropdownHeaderEmailElement = document.getElementById('dropdown-header-profile-email');

    document.getElementById('logoutButton')?.addEventListener('click', authService.logout);

    initDarkModeToggles($profileDropdown); // initialize the dark mode toggle buttons

    userDetailStoreUnsubscribe = userDetailStore.subscribe(({ userDetail }) => populate(userDetail)); // populate the loading state if workspaces loading
    const userDetail = userDetailStore.userDetail;
    populate(userDetail);
  }

  function populate(userDetail: UserDetailType) {
    // check if userDetail == {}
    if (Object.entries(userDetail).length > 0) {
      if (userDetail.user_meta?.profile_pic_url) {
        $headerAvatarBtn!.innerHTML = `<img
                class="w-full h-auto max-w-[35px] max-h-[34px] object-cover"
                src="${userDetail.user_meta.profile_pic_url}"
                alt="Avatar"
              />`;
        $dropdownHeaderAvatarBtn!.innerHTML = `<img
                class="w-full h-auto max-w-[30px] max-h-[30px] object-cover"
                src="${userDetail.user_meta.profile_pic_url}"
                alt="Avatar"
              />`;
      } else {
        $headerAvatarBtn!.innerHTML = `<div class="flex items-center justify-center">
              <div class="w-9 h-9 rounded-full bg-[#6172f3] flex items-center justify-center">
                  <span class="text-white text-lg uppercase">${userDetail.name[0]}</span>
              </div>
          </div>`;
              
        $dropdownHeaderAvatarBtn!.innerHTML = `<div class="flex items-center justify-center">
              <div class="w-9 h-9 rounded-full bg-[#6172f3] flex items-center justify-center">
                  <span class="text-white text-lg uppercase">${userDetail.name[0]}</span>
              </div>
          </div>`;
      }
      $dropdownHeaderNameElement!.innerHTML = userDetail.name;
      $dropdownHeaderEmailElement!.innerHTML = userDetail.email;
    }
  }

  function cleanUp() {
    if (userDetailStoreUnsubscribe) {
      userDetailStoreUnsubscribe();
    }
  }

  function render() {
    return /*html*/`
    <div class="h-[36px]">
      <!-- Account Dropdown -->
      <div id="header-profile-dd"
        class="hs-dropdown inline-flex [--strategy:absolute] [--auto-close:inside] [--placement:bottom-right] relative text-start">
        <button id="header-profile-dd-btn" type="button"
          class="inline-flex shrink-0 items-center size-9 gap-x-3 text-start rounded-full focus:outline-none border border-gray-100 dark:border-neutral-700 justify-center overflow-hidden" aria-haspopup="menu"
          aria-expanded="false" aria-label="Dropdown">
        </button>
    
        <!-- Account Dropdown -->
        <div
          class="hs-dropdown-menu hs-dropdown-open:opacity-100 w-60 transition-[opacity,margin] duration opacity-0 hidden z-20 bg-white rounded-xl shadow-[0_10px_40px_10px_rgba(0,0,0,0.08)] dark:shadow-[0_10px_40px_10px_rgba(0,0,0,0.2)] dark:bg-neutral-900"
          role="menu" aria-orientation="vertical" aria-labelledby="header-profile-dd-btn">
          <div class="p-1 border-b border-gray-200 dark:border-neutral-800">
            <a class="cursor-pointer py-2 px-3 flex items-center gap-x-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="hs-full-screen-modal"
              href="#my-account?tab=my-profile">
              <span id="dropdown-header-profile-avatar" class="border border-gray-100 dark:border-neutral-700 shrink-0 size-8 rounded-full overflow-hidden inline-flex justify-center items-center">
              <!-- <img
                class=""
                src="https://images.unsplash.com/photo-1659482633369-9fe69af50bfb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=3&w=320&h=320&q=80"
                alt="Avatar"
              /> -->
              <div class="flex items-center justify-center">
                <div class="border border-gray-100 dark:border-neutral-700 w-9 h-9 rounded-full bg-[#6172f3] flex items-center justify-center">
                  <span class="text-white text-lg uppercase">c</span>
                </div>
              </div>
              </span>
              <div class="grow">
                <p id="dropdown-header-profile-name"
                  class="text-sm font-semibold text-gray-800 dark:text-neutral-300 line-clamp-1 w-full max-w-[160px] break-words">
                </p>
                <p id="dropdown-header-profile-email" class="text-xs text-gray-500 dark:text-neutral-500 line-clamp-1 w-full max-w-[160px] break-words">
                </p>
              </div>
            </a>
          </div>
          <div class="p-1 max-h-[calc(100vh-230px)] overflow-hidden overflow-y-auto">
            <a class="cursor-pointer flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="profile-modal"
              href="#my-account?tab=my-profile">
              <svg class="shrink-0 mt-0.5 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              My Profile
            </a>
            <a class="cursor-pointer flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="profile-modal"
              href="#my-account?tab=notifications">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-bell shrink-0 mt-0.5 size-4">
                <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
              </svg>
              Notifications
            </a>
            <a class="cursor-pointer flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="profile-modal"
              href="#my-account?tab=refer-and-earn">
              <svg class="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-handshake">
                <path d="m11 17 2 2a1 1 0 1 0 3-3" />
                <path
                  d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
                <path d="m21 3 1 11h-2" />
                <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
                <path d="M3 4h8" />
              </svg>
              Refer & Earn
            </a>
            <a class="cursor-pointer flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="profile-modal"
              href="#my-account?tab=subscription">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-receipt-text size-4">
                <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
                <path d="M14 8H8" />
                <path d="M16 12H8" />
                <path d="M13 16H8" />
              </svg>
              Manage Subscription
            </a>
            <a class="cursor-pointer flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="profile-modal"
              href="#my-account?tab=storage">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-database size-4">
                <ellipse cx="12" cy="5" rx="9" ry="3" />
                <path d="M3 5V19A9 3 0 0 0 21 19V5" />
                <path d="M3 12A9 3 0 0 0 21 12" />
              </svg>
              Manage Storage
            </a>
            <a class="cursor-pointer flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="profile-modal"
              href="#my-account?tab=plans">
              <svg class="size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-badge-dollar-sign">
                <path
                  d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
                <path d="M12 18V6" />
              </svg>
              Plans
            </a>
            <a class="cursor-pointer flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="profile-modal"
              href="#my-account?tab=API-keys">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-braces shrink-0 mt-0.5 size-4">
                <path d="M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1" />
                <path d="M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1" />
              </svg>
              API Access
            </a>
            <a class="cursor-pointer flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="profile-modal"
              href="#my-account?tab=webhooks">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-code-xml shrink-0 mt-0.5 size-4">
                <path d="m18 16 4-4-4-4" />
                <path d="m6 8-4 4 4 4" />
                <path d="m14.5 4-5 16" />
              </svg>
              Webhook Setup
            </a>
            <a class="cursor-pointer flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              aria-haspopup="dialog" aria-expanded="false" aria-controls="profile-modal"
              href="#my-account?tab=manage-team">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-users shrink-0 mt-0.5 size-4">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
    
              Manage Team
            </a>
            <!-- Keeping this one as a sample for the "New" badge
            <a
              class="flex items-center gap-x-3 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800"
              href="#"
            >
              Customization
              <div class="ms-auto">
                <span
                  class="ms-auto inline-flex items-center gap-1.5 py-px px-1.5 rounded text-[10px] leading-4 font-medium bg-gray-100 text-gray-800 dark:bg-neutral-700 dark:text-neutral-300"
                >
                  New
                </span>
              </div>
            </a>
            -->
          </div>
          <div class="px-4 py-3.5 border-y border-gray-200 dark:border-neutral-800">
            <div class="flex justify-between items-center">
              <label for="header-profile-dd-btndm" class="text-sm text-gray-800 dark:text-neutral-300 cursor-pointer">Dark Mode</label>
              <div class="relative inline-block">
                <input 
                  data-hs-theme-switch 
                  type="checkbox" 
                  id="header-profile-dd-btndm"
                  class="theme-toggle relative w-11 h-6 p-px bg-gray-200 border-transparent text-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:ring-blue-600 disabled:opacity-50 disabled:pointer-events-none checked:bg-none checked:text-blue-600 checked:border-blue-600 focus:checked:border-blue-600 dark:bg-neutral-800 dark:border-neutral-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-neutral-900 before:inline-block before:size-5 before:bg-white checked:before:bg-white before:translate-x-0 checked:before:translate-x-full before:rounded-full before:shadow before:transform before:ring-0 before:transition before:ease-in-out before:duration-200 dark:before:bg-neutral-400 dark:checked:before:bg-white" />
              </div>
            </div>
            <!-- End Switch/Toggle -->
          </div>
          <div class="p-1 border-gray-200 dark:border-neutral-800">
            <a type="button"
              class="flex mt-0.5 gap-x-3 py-2 px-3 w-full rounded-lg text-sm text-gray-800 hover:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:bg-gray-100 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:focus:bg-neutral-800 cursor-pointer"
              id="logoutButton">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-log-out shrink-0 size-4 mt-0.5">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" x2="9" y1="12" y2="12" />
              </svg>
              Sign Out
            </a>
          </div>
        </div>
        <!-- End Account Dropdown -->
      </div>
      <!-- End Account Dropdown -->
    </div>
    `;
  }

  return { render, init, MODAL_TABS, cleanUp };
}